import React from 'react'

import {
	actionsColumn,
	conditionNameColumn,
	mainProviderColumn,
	mainSiteColumn,
	providersColumn,
	sitesColumn
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import priceComparisonColumn from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Table/columns/comparison"


export default function PriceComparisonTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		title="Alerts: Price Comparison"
		data={data}
		isLoading={isLoading}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			mainSiteColumn(),
			mainProviderColumn(),
			priceComparisonColumn(),
			...sitesColumn(),
			providersColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)]}
		legend={[
			{
				icon: "percent",
				value: "%",
				label: "Percentage"
			},
			{
				icon: "money-bills",
				value: "$",
				label: "Currency",
				iconProps: { color: "success.dark" }
			},
			{
				icon: "chart-line-down",
				value: "Cheaper",
				label: "Cheaper",
				iconProps: { color: "error.main" }
			},
			{
				icon: "chart-line-up",
				value: "More expensive",
				label: "More Expensive",
				iconProps: { color: "success.main" }
			},
			{
				icon: "chart-line-up-down",
				value: "Cheaper/More expensive",
				label: "Price Difference",
				iconProps: { color: "warning.main" }
			},
		]}
	/>
}